import { TrackingCode } from '@sky-distribution/adapter-core-pc-rest-interfaces';
import { Consent } from '@sky-distribution/digital-gp-submission';
import { Submission } from '../service/Policy.service.type';
import { getSubmissionWithConsents } from './consents';
import { getSubmissionWithProducerData } from './producerData';
import { getProducerDataTrackingCodes, getSubmissionWithTrackingCodes } from './trackingCodes';

export const getSubmissionWithMetaData = (
  submission: Submission,
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
  trackingCodes?: TrackingCode[],
) => {
  const submissionWithConsents = getSubmissionWithConsents(submission, consentStatus, consentDictionary);
  const submissionWithTrackingCodes = getSubmissionWithTrackingCodes(submissionWithConsents, trackingCodes);
  const producerDataTrackingCodes = getProducerDataTrackingCodes(trackingCodes);

  return getSubmissionWithProducerData(
    submissionWithTrackingCodes,
    producerDataTrackingCodes,
  );
};
